module.exports = __webpack_public_path__ + "resources/img/img-acra-point-01-jp.e0dbb02ad009d8d6ea5c9011d2c3fc3d.png";